import { render, staticRenderFns } from "./ListDHRDetailSubparts.vue?vue&type=template&id=6e1c738d&scoped=true&"
import script from "./ListDHRDetailSubparts.vue?vue&type=script&lang=js&"
export * from "./ListDHRDetailSubparts.vue?vue&type=script&lang=js&"
import style0 from "./ListDHRDetailSubparts.vue?vue&type=style&index=0&id=6e1c738d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c738d",
  null
  
)

export default component.exports